import { ArrowDown } from "lucide-react";
import { VILLA_STYLES } from "../../lib/data";

/**
 * VillaTypes — "You Dream It, We Build It."
 * Sits after the Plots section. Light editorial. AI imagery only — no real
 * villa photos reused here (those live in CompletedProjects).
 */
export default function VillaTypes({ onEnquire }) {
  return (
    <section
      id="villas"
      data-testid="villas-section"
      className="bg-[#EBE7DF] text-[#1A362D] py-20 md:py-32"
    >
      <div className="max-w-[110rem] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14 md:mb-20 items-end">
          <div className="reveal lg:col-span-7">
            <h2 className="font-serif-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[6.5rem] leading-[0.95] tracking-tight font-light">
              You Dream It,
              <br />
              <em className="font-normal">We Build It.</em>
            </h2>
            <button
              data-testid="villa-types-cta"
              onClick={() =>
                onEnquire?.({ name: "A custom villa — design enquiry" })
              }
              className="btn-primary mt-10 group"
            >
              Start Designing Your Villa
              <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
            </button>
          </div>

          <div className="reveal lg:col-span-5 lg:pl-12 lg:border-l lg:border-[#1A362D]/15">
            <p className="text-[#3A453B] text-base md:text-lg leading-relaxed">
              Pick from <strong className="text-[#1A362D]">four hand-curated architectural styles</strong> —
              modern RCC, hand-hewn Russian timber, RCC-and-wood hybrid, or
              old-world Portugese — and refine the layout, materials and finishes
              with our panel of architects. Part of The Farmhouse Project.
            </p>
          </div>
        </div>

        {/* 4 style cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {VILLA_STYLES.map((v, idx) => (
            <article
              key={v.id}
              data-testid={`villa-style-${v.id}`}
              className="reveal flex flex-col group"
              style={{ transitionDelay: `${idx * 90}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[#F7F5F0]">
                <img
                  src={v.image}
                  alt={v.name}
                  className="w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 bg-gradient-to-t from-[#0A130F]/85 via-[#0A130F]/20 to-transparent">
                  <p className="text-[10px] tracking-[0.28em] uppercase text-[#E2CFA1] font-medium mb-1">
                    {v.tagline}
                  </p>
                  <h3 className="font-serif-display text-2xl sm:text-3xl text-[#F7F5F0] leading-tight font-light">
                    {v.name}
                  </h3>
                </div>
              </div>
              <p className="mt-4 text-[#3A453B] text-sm md:text-base leading-relaxed">
                {v.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
